﻿import { useNavigate } from 'react-router-dom';

import Icon from '../components/AppIcon';

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/dashboard-overview');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        {/* 404 Illustration */}
        <div className="mb-8">
          <div className="w-32 h-32 mx-auto bg-primary-50 rounded-full flex items-center justify-center mb-6">
            <Icon name="AlertTriangle" size={64} color="var(--color-primary)" />
          </div>
          <h1 className="text-6xl font-bold text-primary mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-text-primary mb-4">Page Not Found</h2>
          <p className="text-text-secondary mb-8">
            The page you're looking for doesn't exist or has been moved to another location.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="space-y-4">
          <button
            onClick={handleGoHome}
            className="w-full bg-primary text-white py-3 px-6 rounded-lg hover:bg-primary-700 transition-colors duration-200 flex items-center justify-center space-x-2"
          >
            <Icon name="Home" size={20} />
            <span>Go to Dashboard</span>
          </button>

          <button
            onClick={handleGoBack}
            className="w-full bg-secondary-100 text-secondary-700 py-3 px-6 rounded-lg hover:bg-secondary-200 transition-colors duration-200 flex items-center justify-center space-x-2"
          >
            <Icon name="ArrowLeft" size={20} />
            <span>Go Back</span>
          </button>
        </div>

        {/* Help Links */}
        <div className="mt-8 pt-6 border-t border-border">
          <p className="text-sm text-text-secondary mb-4">Need help? Try these:</p>
          <div className="flex justify-center space-x-6 text-sm">
            <button className="text-primary hover:text-primary-700 transition-colors duration-200">
              Contact Support
            </button>
            <button className="text-primary hover:text-primary-700 transition-colors duration-200">
              Documentation
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
